import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Button, Checkbox } from 'next-common-lib';

export const TermsTitle = ({ name, label, btnOnClick, isOnlyCheck, disabled }) => {
  const { control, getValues } = useFormContext();

  const {
    field: { value, onChange },
  } = useController({ name, control });

  const isShowContents = () => {
    return getValues(`${name}-icon`)
      ? {
          size: 'md',
          className: 'ic-up',
        }
      : { size: 'md', className: 'ic-down' };
  };
  return (
    <div className="term-title">
      <Checkbox id={name} checked={value} label={label} onChange={onChange} title={label} disabled={disabled} />
      {!isOnlyCheck && (
        <Button componentType="etc" className="normal circle" onClick={btnOnClick} iconInfo={isShowContents()} />
      )}
    </div>
  );
};
TermsTitle.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  btnOnClick: PropTypes.func,
  isOnlyCheck: PropTypes.bool,
  disabled: PropTypes.bool,
};
TermsTitle.defaultProps = {
  name: '',
  label: '',
  btnOnClick: () => {},
  isOnlyCheck: false,
  disabled: false,
};
export default TermsTitle;
